module.exports = __webpack_public_path__ + "img/12.6f9e8b23.png";